// extracted by mini-css-extract-plugin
module.exports = {"modal":"marketUpdate-module--modal--1jC9x","overlay":"marketUpdate-module--overlay--1k0Yc","closeButton":"marketUpdate-module--closeButton--2Wjcf"};